export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/truck-icon.2765628e.svg","height":12,"width":26,"blurWidth":0,"blurHeight":0};